<template>
 <!-- <ion-content> -->
     <component :is="isMobile?'ion-content':'div'">
   <ion-refresher v-if="isMobile" @ionRefresh="doRefresh($event)">
                    <ion-refresher-content
                        pulling-icon="chevron-down-circle-outline"
                        pulling-text="Pull to refresh"
                        refreshing-spinner="circles"
                        refreshing-text="Refreshing...">
                    <ion-spinner name="lines"></ion-spinner>
                    </ion-refresher-content>
      
    </ion-refresher>
       <div slot="fixed" class="fullscreen approveagent-wrapper " style="padding: 0!important;">
      
        
     
        <CCard class="cardstyle">
            
            <CCardHeader class="grey-header d-flex">
                
                <CRow class="flex-flow-column">
                    <CCol>
                        <strong>{{ $t("approveAgt.title") }}</strong>
                    </CCol>
                    
                    <p class="desc">{{ $t("approveAgt.apprvAgtTxt") }}</p>
                </CRow>
                <div v-if="isShowAgentTable" class="generate-ex-btn" @click="navToGuide" >
                    <p class="guide-content">How to approve an Agent?</p>
            <!-- <CIcon name="cil-media-play"  /> -->
            <CIcon name="cil-external-link"/>
            <!-- <CIcon name="cil-external-link" v-c-tooltip.hover="{placement: 'left', content:'How to approve an Agent?',  active:true }"/> -->
                </div>
                <div v-if="!isShowAgentTable" class="ml-auto">
                    <CButton
                            @click="showAgentTable()"
                            size="sm"
                            color="success"
                            class="ml-auto btn-lit-blue mob-w100 "
                    >{{ $t("approveAgt.change") }}
                    </CButton>
                </div>
            </CCardHeader>
              
 
            <!-- {{BREADCRUMB_STATUS.BREADCRUMB_ITEM + BREADCRUMB_STATUS.PRESENT_ITEM}} -->
            <!-- b2bid - {{aprvAgtObj.allAgts.agency.b2bid}}
               isDisable  - {{aprvAgtObj.navBarItems[0].details}} -->
            <!-- select agent details aprvAgtObj.allAgts.agtDetLabel v-if="aprvAgtObj.allAgts.agency.b2bid"-->

            <!-- :isCancelled="aprvAgtObj.isCancel" -->

            <CCardBody class="seldrop d-flex ai-center jc-center">
                
                <!-- <cDropDown
                  class=" d-flex app-dropdown-wrapper loginPg.frgtPwd"
                  :isDisable="toDisableAgentDP()"
                  :label="!toDisableAgentDP() ? $t('approveAgt.slctName') : ''"
                  :ctrlName="'agencyname'"
                  :ctrlCode="'registrationid'"
                  :selValue="aprvAgtObj.agencyInfo.agencyDet"
                  :isAllowEmpty="false"
                  :isShowCode="false"
                  :isMultiple="false"
                  :isSearchable="true"
                  :url="getAllPendingAgentServiceURL()"
                  v-on:input="onAgentChange"
                /> -->
                <div class="overflow-x-auto">
                    <!-- <cFullScreen v-if="isShowAgentTable">
                        <template #fullScreen> -->

                            <div v-if="isShowAgentTable" class="w-100" >
                                <div v-if="pendingAgentList" id="user-manage-table">
                                    <cTable
                                            :items="pendingAgentComputedList"
                                            :fields="pendingAgentListFields"
                                            column-filter
                                            items-per-page-select
                                            :items-per-page="approveAgtTableWatchList.itemsPerPage"
                                            hover
                                            :sorter='{  resetable: true }'
                                            @row-clicked="onAgentChange"
                                            pagination
                                            :loading="isLoading"
                                            class="table-striped"
                                            :sorterValue="{ column: 'created_at', asc: false }"
                                            @filtered-items-change="getFilteredAgentCount"
                                            @page-change="onPageChange"
                                            @pagination-change="onPaginationChange"
                                             @getFields="onSaveColumns"
                                    :tableWatchList="approveAgtTableWatchList"
                                    :manageColumn="true"
                                    :paginationLenOption="true"
                                    >

                                        <!-- <template #over-table>
                       <cManageColumns v-if="pendingAgentListFields&&pendingAgentListFields.length>0" :lsFields="pendingAgentListFields" @getFields="onSaveColumns"/>

                                            <cPaginationLenOption :paginationWatchLs="approveAgtTableWatchList"/>
                                           
                                        </template> -->

                                        <template #no-items-view>
                                            <div class="text-center my-5">
                                                <h2 class="no-data-title">{{  isLoading?'':$t("approveAgt.noAgt") }}</h2>
                                            </div>
                                        </template>

                                        <template  #status='{item}'>
                                            <td>
                                                <CBadge color='warning'>
                                                    {{
                                                    item.status==regStatus.pending?$t('approveAgt.pending'):item.status==regStatus.approved?$t("approveAgt.approved")
                                                    :item.status==regStatus.rejected ?$t("approveAgt.rejected") :null
                                                    }}
                                                </CBadge>
                                            </td>

                                        </template>


                                        <template #action="{item}">
                                            <td class="py-2">
                                                <!--                  <CButton @click="onAgentChange(item)">-->
                                                <!--                  <div v-if="item.status==regStatus.pending" >{{ $t("approveAgt.pending") }}</div>-->
                                                <!--                  <div v-else-if="item.status==regStatus.approved" >{{ $t("approveAgt.approved") }}</div>-->
                                                <!--                   <div v-else-if="item.status==regStatus.rejected">{{ $t("approveAgt.rejected") }}</div>-->
                                                <!--                   </CButton>-->
                                                <CButton @click="onAgentChange(item)" v-if="item.status==regStatus.pending"
                                                         class="btn-manage b-radius-3px hover-none btn-success btn-sm">
                                                    <span> {{ $t("approveAgt.approve") }} </span>
                                                </CButton>
                                                <CButton @click="onAgentChange(item)"
                                                         class="btn-manage b-radius-3px hover-none btn-success btn-sm"
                                                         v-else-if="item.status==regStatus.approved">
                                                    <span>{{ $t("approveAgt.approved") }}</span>
                                                </CButton>
                                                <CButton @click="onAgentChange(item)"
                                                         v-else-if="item.status==regStatus.rejected"
                                                         class="action-c-btn btn-danger">
                                                    <span>{{ $t("approveAgt.rejected") }}</span>
                                                </CButton>
                                            </td>
                                        </template>
                                        <template #created_at="{item}">
                                            <td class="py-2">
                                                <!-- {{item.created_at | timeAgoFormat}} -->
                                              {{item.created_at}}

                                            </td>
                                        </template>
                                        <template #mobile_number="{item}">
                                            <td class="py-2">{{ item.mobile_code + item.mobile_number}}</td>
                                        </template>
                                        <!-- <template #contact_countrycode="{item}">
                                           <td class="py-2">{{ item.contact_countrycode | countryName}}</td>
                                       </template> -->
                                    </cTable>
                                </div>
                            </div>
                        <!-- </template></cFullScreen> -->
                    <div v-if="!isShowAgentTable">
                        <div
                                v-if="
                aprvAgtObj &&
                  aprvAgtObj.agencyInfo &&
                  aprvAgtObj.agencyInfo.agencyDet &&
                  aprvAgtObj.agencyInfo.agencyDet.agencyname
              "
                                class="selected_agent"
                        >
                            <div
                                    v-if="!aprvAgtObj.navBarItems[0].details"
                                    class="text-center d-flex"
                            >
                                <strong>{{
                                    aprvAgtObj.agencyInfo.agencyDet.agencyname
                                    }}</strong>
                            </div>
                        </div>
                    </div>
                </div>

            </CCardBody>
            <div v-if="!isShowAgentTable">
                <CCardHeader
                        v-if="
              aprvAgtObj &&
                aprvAgtObj.agencyInfo &&
                aprvAgtObj.agencyInfo.agencyDet &&
                aprvAgtObj.agencyInfo.agencyDet.agencyname
                "
                        class="jc-center-row"
                >
                    <div v-if="!aprvAgtObj.navBarItems[0].details" class="text-center">
                        <!-- <strong>{{aprvAgtObj.agencyInfo.agencyDet.agencyname}}</strong> -->
                    </div>
                    <CRow>
                        <cBreadCrumb
                                :toNav="true"
                                :item="aprvAgtObj.navBarItems"
                                @getStatus="getNavBarStatus"
                                class="breadcrumbs-approve"
                        ></cBreadCrumb>
                    </CRow>
                </CCardHeader>
            </div>

            <!-- show agent details -->
            <div v-if="!isShowAgentTable">
                <CForm v-if="aprvAgtObj.navBarItems[0].details">
                    <CCardBody
                            class="curvedBorder card-w-shadow-row m-auto">
                        <div class="overflow-x-auto">
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/Agency_Name.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <strong>{{ $t("approveAgt.agencyName") }}</strong>
                                    </CCol>
                                    <CCol>{{ aprvAgtObj.agencyInfo.agencyDet.agencyname }}</CCol>
                                </div>
                            </CRow>

                            <CRow>
                                <div class="approve-f-icon">
                                    <img
                                            src="@imgPath/img/svg/icons/Buisness_Registration_Number.svg"
                                            alt=""
                                    />
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.busRegNo") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.business_regno }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/IATA_Number.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.iataNo") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>{{ aprvAgtObj.agencyInfo.agencyDet.iatanumber }}</div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/name.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtName") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_name }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/Address.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtAdrs") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_address }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/City.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtCity") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_city }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/State.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtState") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_state }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/State.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t('approveAgt.agtCountry') }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_country_name }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/postal_code.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtPostal") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div>
                                            {{ aprvAgtObj.agencyInfo.agencyDet.contact_postalcode }}
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon ">
                                    <img
                                            src="@imgPath/img/svg/icons/Contact_Email_ID.svg"
                                            alt=""
                                    />
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.emailName") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div class="email-text">{{ aprvAgtObj.agencyInfo.agencyDet.emailid }}</div>
                                    </CCol>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="approve-f-icon">
                                    <img src="@imgPath/img/svg/icons/name.svg" alt=""/>
                                </div>
                                <div class="subtitile-details">
                                    <CCol>
                                        <div>
                                            <strong>{{ $t("approveAgt.agtNo") }}</strong>
                                        </div>
                                    </CCol>
                                    <CCol>
                                        <div class="d-flex">
                                            <div class="pr-10px">
                                                {{ " " + aprvAgtObj.agencyInfo.agencyDet.mobile_code }}
                                            </div>
                                            <div>
                                                {{ aprvAgtObj.agencyInfo.agencyDet.mobile_number }}
                                            </div>
                                        </div>
                                    </CCol>
                                </div>
                            </CRow>

                        </div>





                    </CCardBody>

                    <div class="card-footer d-flex justify-content-between">



                            <CButton
                                    color="danger"
                                    @click="isShowAgentTable=true"
                                    class="action-c-btn">

                                {{ $t("approveAgt.goBack") }}
                            </CButton>

                        <div class="d-flex justify-content-end">

                            <CCol class="pl-0px">
                                <CButton
                                        color="danger"
                                        @click="cancelButton()"
                                        class="action-c-btn"
                                >
                                    <img
                                            src="@imgPath/img/svg/icons/close.svg"
                                    />
                                    {{ $t("approveAgt.rejectBtn") }}
                                </CButton
                                >
                            </CCol>
                            <CCol class="pr-0px">
                                <CButton
                                        color="success"
                                        @click="nextButton()"
                                        class="action-c-btn"
                                ><img
                                        src="@imgPath/img/svg/icons/correct.svg"
                                />{{ $t("approveAgt.approveBtn") }}
                                </CButton
                                >
                            </CCol>
                        </div>
                    </div>
                </CForm>
            </div>
            <cAlertModal v-if="aprvAgtObj.agencyInfo.approved"
                         :buttonList="[
              {
                name: $t('approveAgt.noBtn'),
                func: cancelModal,
                color: 'danger'
              },
              {
                name: $t('approveAgt.yesBtn'),
                func: rejectAgent,
                color: 'success'
              }
                ]"
                         :status="modalStatus"
                         :show="aprvAgtObj.agencyInfo.approved"
                         :desc="$t('approveAgt.reject',{agent:aprvAgtObj.agencyInfo.agencyDet.agencyname})"
            ></cAlertModal>

            <!-- show select city part -->

            <div v-if="!isShowAgentTable">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <CForm @submit.prevent="handleSubmit(nextButton)" v-if="aprvAgtObj.navBarItems[1].details">
                        <CCardBody

                                class=" curvedBorder m-auto"
                        >
                            <div class="row flex-flow-column jc-center ai-center">
                                <div class="col-md-6 col-sm-12">
                                    <cDropDown
                                            key="country"
                                            :label="$t('approveAgt.agtCountry')"
                                            :ctrlName="'value'"
                                            :ctrlCode="'countrycode'"
                                            :isShowCode="true"
                                            :isMultiple="false"
                                            :isSearchable="true"
                                            :url="getCountryServiceURL()"
                                            v-on:input="onCountryChange"
                                            :selValue="aprvAgtObj.selCity.country"
                                            rules="required"
                                            :isAddCountry="true"
                                            :buttonName="'Add Country'"
                                            :resultEmpty="'No Country Found'"
                                            :optionEmpty="'No Country Found'"
                                            @addCountry="navigateToState"
                                    />
                                </div>
                                <div class="col-md-6 col-sm-12 mt-10px">
                                    <div v-if="aprvAgtObj.selCity.showState">
                                        <cDropDown
                                                key="state"
                                                :label="$t('approveAgt.agtState')"
                                                :ctrlName="'statename'"
                                                :ctrlCode="'statecode'"
                                                :isShowCode="true"
                                                :isMultiple="false"
                                                :isSearchable="true"
                                                :showError="true"
                                                :url="getStateServiceURL()"
                                                :cntryCode="aprvAgtObj.selCity.country"
                                                v-on:input="onStateChange"
                                                v-model="aprvAgtObj.selCity.state"
                                                :isAddCountry="true"
                                                :optionEmpty="$t('approveAgt.noState')"
                                                :resultEmpty="$t('approveAgt.noList')"
                                                :buttonName="$t('approveAgt.btnName')"
                                                @addCountry="navigateToState"
                                                rules="required"
                                        />
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <div class="col-md-6 col-sm-12 m-auto pl-10px">
                                <CRow
                                        class="flex-flow-unset mb-20px"
                                        v-if="
                      aprvAgtObj.selCity.country &&
                        aprvAgtObj.selCity.country.countrycode &&
                        aprvAgtObj.selCity.state &&
                        aprvAgtObj.selCity.state.statecode
                    "
                                >
                                    <CCol sm="6" md="6">{{ $t("approveAgt.samAgtCode") }}</CCol>
                                    <CCol sm="6" md="6"
                                    >{{ aprvAgtObj.selCity.country.countrycode
                                        }}{{ aprvAgtObj.selCity.state.statecode
                                        }}{{ "XXXXX" }}
                                    </CCol
                                    >
                                </CRow>
                            </div>



                            <!--                                    <CRow v-if="aprvAgtObj.navBarItems[2].details || aprvAgtObj.navBarItems[1].details"-->
                            <!--                                          class="d-flex justify-content-end form-cta-btn ">-->
                            <!--                                        <CCol>-->
                            <!--                                            <CButton-->
                            <!--                                                    color="danger"-->
                            <!--                                                    @click="cancelButton()"-->
                            <!--                                                    class="action-c-btn "-->
                            <!--                                            >Back-->
                            <!--                                            </CButton-->
                            <!--                                            >-->
                            <!--                                        </CCol>-->
                            <!--                                        <CCol>-->

                            <!--                                            <CButton color="success" type="submit" class="action-c-btn "-->
                            <!--                                            ><img-->
                            <!--                                                    src="@imgPath/img/svg/icons/next.svg"-->
                            <!--                                                    class="h-28px"-->
                            <!--                                            />Next-->
                            <!--                                            </CButton-->
                            <!--                                            >-->
                            <!--                                        </CCol>-->
                            <!--                                    </CRow>-->
                            <!--<CCol
                                    class="d-flex justify-content-end  curvedBorder pd-0px"
                                    v-if="
            aprvAgtObj.navBarItems[2].details ||
              aprvAgtObj.navBarItems[1].details
          "
                            >
                                <CButton color="success" type="submit" class="action-c-btn "
                                ><img
                                        src="@imgPath/img/svg/icons/next.svg"
                                        class="h-28px"
                                />Next
                                </CButton
                                >
                            </CCol>-->
                        </CCardBody>
                        <div class="card-footer">
                            <div class="d-flex justify-content-end" v-if="aprvAgtObj.navBarItems[2].details || aprvAgtObj.navBarItems[1].details">
                                <div class="pl-0px col">
                                    <button type="button" class="btn action-c-btn btn-danger"    @click="cancelButton()"><img
                                            src="@imgPath/img/svg/icons/back-circle.svg">{{ $t("approveAgt.back")}}
                                    </button>
                                </div>
                                <div class="pr-0px col d-flex justify-content-end">
                                    <button  class="btn action-c-btn btn-success" type="submit"><img
                                            src="@imgPath/img/svg/icons/next.svg">{{ $t("approveAgt.nextBtn")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CForm>
                </ValidationObserver>
            </div>

            <!-- show payment part -->

            <div v-if="!isShowAgentTable">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <!-- <ValidationObserver v-slot="{ handleSubmit }">
                        <CForm @submit.prevent="aprvAgtObj.paymentSettingId.length?handleSubmit(nextButton):invalidText=true"> -->

                    <CForm @submit.prevent="handleSubmit(nextButton)" v-if="aprvAgtObj.navBarItems[2].details">
                        <CCardBody

                                class=" curvedBorder m-auto spl-tag"
                        >
                            <div class="row flex-flow-column ai-center">
                                <!-- <div class="col-md-6">
                                    <cCurrencyDropDown
                                      v-on:input="onCurrencyChange"
                                      :selValue="aprvAgtObj.payMethod.currency"
                                      :label="$t('approveAgt.currName')"
                                      :ctrlName="'code'"
                                      :ctrlCode="'code'"
                                      :isShowCode="true"
                                      :isMultiple="true"
                                      :isSearchable="true"
                                      :url="getCurrencyServiceURL()"
                                      rules="required"
                                    />
                                    </div> -->

                                <div class="col-md-8 col-sm-12">


                                    <CRow class="max-width-550 m-auto">
                                        <div class="d-flex align-item-center">
                                            <div class="text-center font-bold min-w-150 d-flex mr-10px">{{
                                                $t("approveAgt.agtType")
                                                }}
                                            </div>
                                            <div>
                                                <CRow class="jc-center ">
                                                    <div class="slider-wrapper-mf">
                                                        <CButton v-if="clientCode!=allClientCode.AZ"
                                                                 :pressed.sync="
                            aprvAgtObj.agtType.agentType.value == 1
                          "
                                                                 class=""
                                                                 @click="onAgentTypeChange()"
                                                        >{{ $t("approveAgt.preAgt") }}
                                                        </CButton
                                                        >

                                                        <CButton
                                                                :pressed.sync="
                            aprvAgtObj.agtType.agentType.value == 2
                          "
                                                                class=""
                                                                @click="onAgentTypeChange()"
                                                        >{{ $t("approveAgt.postAgt") }}
                                                        </CButton
                                                        >
                                                    </div>
                                                </CRow>
                                            </div>
                                        </div>
                                    </CRow>
                                    <CRow class="max-width-550 m-auto mob-drop-down-currency  approve-flow-align-wrap">
                                        <div
                                                v-if="aprvAgtObj.agtType.agentType.value == 1"
                                                class=" curvedBorder w-100"
                                        >
                                            <cOrgCurrencyDp
                                                    v-on:input="onCurrencyChange"
                                                    :selValue="aprvAgtObj.payMethod.currency"
                                                    :label="$t('approveAgt.currName')"
                                                    :isAllowEmpty="true"
                                                    :ctrlCode="'id'"
                                                    :isShowCode="true"
                                                    :isMultiple="true"
                                                    :isSearchable="true"
                                                    :url="getOrgCurrencyServiceURL()"
                                                    rules="required"
                                            />

                                            <div class="verticalspace"/>
                                        </div>

                                        <div
                                                v-if="aprvAgtObj.agtType.agentType.value == 2"
                                                class="max-width-550 m-auto"
                                        >
                                            <br/>

                                            <cOrgCurrencyDp
                                                    v-on:input="onCurrencyChange"
                                                    :selValue="aprvAgtObj.payMethod.currency"
                                                    :label="$t('approveAgt.currName')"
                                                    :isAllowEmpty="true"
                                                    :ctrlCode="'id'"
                                                    :isShowCode="true"
                                                    :isMultiple="true"
                                                    :isSearchable="true"
                                                    :url="getOrgCurrencyServiceURL()"
                                                    rules="required"
                                                    class="approve-flow-align-wrap currecncy-approve-a"
                                            />



                                            <div class="d-flex mt-15px">

                                                <!-- <ValidationProvider tag="div" rules="required"   v-slot="{ errors }"> -->
                                                <label class="min-150px"> {{ $t("approveAgt.statementType")}} </label>
                                                <CRow class="d-flex justify-content-center mob-jc-left">

                                                    <cRadioButton
                                                            v-for="Item in aprvAgtObj.agtType.postPaidType.payTypeList"
                                                            class="radio-style app-radio"
                                                            :key="Item.code"
                                                            :val="Item.value"
                                                            :selValue="aprvAgtObj.agtType.postPaidType.selTypeVal"
                                                            :value="Item.code"
                                                            :name="Item.name"
                                                            :label="Item.name"
                                                            rules="required"
                                                            @input="onPayTypeChange(Item)"
                                                    />
                                                </CRow>

                                            </div>
                                            <!-- </ValidationProvider> -->
                                            <br/>
                                            <!-- {{aprvAgtObj.agtType.postPaidType.paymentMethod}} -->
                                            <div v-if="aprvAgtObj.agtType.postPaidType.showSch" class="d-flex label-150px col-d-flex position-relative">
                                                <cDropDown
                                                        :label="$t('approveAgt.paySchedule')"
                                                        :ctrlName="'name'"
                                                        :ctrlCode="'scheduleid'"
                                                        :isShowCode="false"
                                                        :isMultiple="false"
                                                        :isSearchable="true"
                                                        :selValue="aprvAgtObj.agtType.postPaidType.paymentMethod"
                                                        v-on:input="onScheduleChange"
                                                        :url="getPaymentScheduleURL()"
                                                        rules="required"
                                                        class="w-100 approve-label-new "
                                                />
                                                <cHelpTip class="position-absolute m-auto top-0 bottom-0 right--30px" :content="$t('helpTip.approveAgtSchedule')"></cHelpTip>
                                            </div>
                                            <div class="" body-wrapper>
                                                <div
                                                        v-if="
                        aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'W'
                      "
                                                        class="note-wrapper d-flex ml-170px"
                                                >
                                                    <div class="note-img">
                                                        <img src="@imgPath/img/svg/icons/idea.svg"/>
                                                    </div>
                                                    <div class="note-text">
                                                        <div class="title">
                                                            {{ $t("approveAgt.agtTypeWeek") }}
                                                        </div>
                                                        <!-- class="pre-formatted" -->
                                                        <div
                                                                v-if="aprvAgtObj.agtType.postPaidType.paymentMethod&&
                            aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 1 || aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 3
                          "
                                                                class="msg"
                                                        >
                                                            {{ $t("approveAgt.agtWeeklyS1Txt",{"id":aprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid}) }}
                                                        </div>
                                                        <div
                                                                v-if="aprvAgtObj.agtType.postPaidType.paymentMethod&&
                            aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 2 || aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 4
                          "
                                                                class="msg"
                                                        >
                                                            {{ $t("approveAgt.agtWeeklyS2Txt",{"id":aprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid}) }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                        v-if="
                        aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'TW'
                      "
                                                        class="note-wrapper d-flex ml-170px"
                                                >
                                                    <div class="note-img">
                                                        <img src="@imgPath/img/svg/icons/idea.svg"/>
                                                    </div>
                                                    <div class="note-text">
                                                        <div class="title">
                                                            {{ $t("approveAgt.agtTypeTwice") }}
                                                        </div>
                                                        <!-- class="pre-formatted" -->
                                                        <div
                                                                v-if="aprvAgtObj.agtType.postPaidType.paymentMethod&&
                            aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 1 || aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 3
                          "
                                                                class="msg"
                                                        >
                                                            {{ $t("approveAgt.agtTwiceS1Txt") }}<br>
                                                            {{ $t("approveAgt.agtTwiceS2Txt") }}
                                                        </div>
                                                        <div
                                                                v-if="aprvAgtObj.agtType.postPaidType.paymentMethod&&
                            aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 2 || aprvAgtObj.agtType.postPaidType.paymentMethod
                              .scheduleid == 4
                          "
                                                                class="msg"
                                                        >
                                                            {{ $t("approveAgt.agtTwiceS2Txt") }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                        v-if="
                        aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'M'
                      "
                                                        class="note-wrapper d-flex ml-170px"
                                                >
                                                    <div class="note-img">
                                                        <img src="@imgPath/img/svg/icons/idea.svg"/>
                                                    </div>
                                                    <div class="note-text">
                                                        <div class="title">
                                                            {{ $t("approveAgt.agtTypeMonthly") }}
                                                        </div>
                                                        <!-- class="pre-formatted" -->
                                                        <div class="msg">
                                                            {{ $t("approveAgt.agtMonthS1Txt",{"id":aprvAgtObj.agtType.postPaidType.paymentMethod.scheduleid}) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br/>
                                            <div v-if="aprvAgtObj.payMethod.currency"  class="d-flex mb-15px">
                                                <label class="min-150px mr-15px mb-0px align-item-center d-flex">{{ $t("approveAgt.creditLimit") }}</label>
                                                <cCurrencyBoxes
                                                        class="w-100 w-100-currency_field pr-15px inner-br-none"
                                                        :currItems="aprvAgtObj.payMethod.currency"
                                                        :placeholder="$t('approveAgt.creditPl')"
                                                        rules="required|onlynumber|min_val:0"
                                                        
                                                />
                                            </div>
                                            <div class="d-flex align-item-center pt-15px">
                                                <label class="min-150px"> {{ $t("approveAgt.creditLimitType")}} </label>

                                                <CRow class="d-flex justify-content-center mob-jc-left mr-10px">

                                                    <cRadioButton
                                                            v-for="Item in aprvAgtObj.agtType.postPaidType.creditLimitLs"
                                                            class="radio-style app-radio"
                                                            :key="Item.code"
                                                            :val="Item.value"
                                                            :selValue="aprvAgtObj.agtType.postPaidType.selCreditLimit"
                                                            :value="Item.code"
                                                            :name="Item.name"
                                                            :label="Item.name"
                                                            rules="required"
                                                            @input="onCreditLimitChange(Item)"
                                                    />
                                                </CRow>
                                                <cHelpTip :content="$t('helpTip.approveAgtCrdtlimit')"></cHelpTip>
                                            </div>


                                            <div class="d-flex ">
                                                <div
                                                        v-if="aprvAgtObj.agtType.postPaidType.selCreditLimit.code == 'F'"
                                                        class="note-wrapper d-flex ml-170px"
                                                >
                                                    <div class="note-img">
                                                        <img src="@imgPath/img/svg/icons/idea.svg"/>
                                                    </div>
                                                    <div class="note-text">
                                                        <!--                                                    <div class="title">-->
                                                        <!--                                                        {{ $t("approveAgt.fixedStatement") }}-->
                                                        <!--                                                    </div>-->
                                                        <div class="title">
                                                            {{ $t("approveAgt.fixedStatement") }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                        v-else
                                                        class="note-wrapper d-flex ml-170px"
                                                >
                                                    <div class="note-img">
                                                        <img src="@imgPath/img/svg/icons/idea.svg"/>
                                                    </div>
                                                    <div class="note-text">
                                                        <div class="title">
                                                            {{ $t("approveAgt.creditLimStatement",{type:aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'W'?'week':
                                                            aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'M'?'Month':'Twice per Week'}) }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="link-drop-btn" :class={rotate:aprvAgtObj.isAdvanceSettings} @click="aprvAgtObj.isAdvanceSettings=!aprvAgtObj.isAdvanceSettings">
                                                <span>{{ $t("approveAgt.advSettings") }}</span>
                                            </div>
                                            <br />
                                            <div class="ml-170px">

                                                <label v-if="aprvAgtObj.isAdvanceSettings" class="d-flex">
                <span>
                    {{$t('approveAgt.maxExtTime') }} ( {{ aprvAgtObj.isAdvanceSettings ? $t("approveAgt.perStatement"): null }} )
                </span>
                                                    <cHelpTip :content="$t('helpTip.approveAgtExtensionTime')"></cHelpTip>
                                                </label>

                                                <cTextInputComponent v-if="aprvAgtObj.isAdvanceSettings"
                                                                     v-model="aprvAgtObj.agtType.postPaidType.extensionTime"
                                                                     :name="$t('approveAgt.maxExtTime')"
                                                                     class="inner-label-none"
                                                                     rules="onlyNumber|max:3"
                                                                     :maxLength="3"
                                                />
                                                <!--                                             {{ aprvAgtObj.isAdvanceSettings ? $t("approveAgt.perStatement"): null }}-->

                                                <br />

                                                <div v-if="aprvAgtObj.isAdvanceSettings" class="c-pointer checkbox-all d-flex mb-15px">
                                                    <div  class="checkbox">
                                                        <input id="crs" type="checkbox" :checked="aprvAgtObj.agtType.postPaidType.isBlockStatement" 
                                                        v-on:input="onToggleBlockTicket()" />
                                                        <span @click="onToggleBlockTicket()">{{' '+ $t('approveAgt.blkTckt') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CRow>


                                    <!-- <label>
                                        <strong>
                                            {{ $t("approveAgt.payName") }}
                                        </strong>
                                    </label>
                                    <div class="row">

                                        <div class="cus-checkbox">
                                            <div class="wrapper">

                                                <div class="card-wrap">
                                                    <div class="wrap"
                                                         v-for="(payList, index) in paymentListGroup"
                                                         :key="'p'+index">

                                                        <div>
                                                            <CRow>
                                                                <div class="title">
                                                                    <strong>{{payList.groupName}}</strong></div>
                                                            </CRow>
                                                            <CRow>

                                                                <label
                                                                        class="card-c "
                                                                        :for="payList.groupName+index"
                                                                        v-for="(payment, index) in payList.payment"
                                                                        :key="payList.groupName+index"
                                                                        v-bind:class="{active: aprvAgtObj.paymentSettingId.includes(payment.paymentSettingsId)}">

                                                                    <input
                                                                            class="d-none"
                                                                            type="checkbox"
                                                                            :checked='aprvAgtObj.paymentSettingId.includes(payment.paymentSettingsId)'
                                                                            @input="onPaymentTypeChange(payment.paymentSettingsId)"
                                                                            :id="payList.groupName+index"
                                                                    />
                                                                    <div> {{ payment.providerName }}</div>

                                                                </label>
                                                            </CRow>
                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div>


                                            </div>
                                        </div>
                                    </div>



                                    <div v-if="(invalidText)">
                                        <label class='invalid-feedback icon'>
                                            {{$t('approveAgt.invalidPaymentType')}}
                                        </label>

                                    </div> -->

                                    <!-- <cDropDown
                                        key="payment"
                                        :label="$t('approveAgt.payName')"

                                        :ctrlName="'name'"
                                        :ctrlCode="'code'"
                                        :isAllowEmpty="true"
                                        :isShowCode="false"
                                        :isMultiple="true"
                                        :isSearchable="true"
                                        :url="getPaymentMethodURL()"
                                        v-on:input="onPaymentMethodChange"
                                        :selValue="aprvAgtObj.payMethod.paymentType"
                                         rules="required"


                                     /> -->
                                </div>
                            </div>
                            <br/>

                            <!--                                    <CRow v-if="aprvAgtObj.navBarItems[2].details || aprvAgtObj.navBarItems[1].details"-->
                            <!--                                          class="d-flex justify-content-end form-cta-btn ">-->
                            <!--                                        <CCol>-->


                            <!--                                            <CButton-->
                            <!--                                                    color="danger"-->
                            <!--                                                    @click="cancelButton()"-->
                            <!--                                                    class="action-c-btn "-->
                            <!--                                            >Back-->
                            <!--                                            </CButton-->
                            <!--                                            >-->
                            <!--                                        </CCol>-->
                            <!--                                        <CCol>-->

                            <!--                                            <CButton color="success" type="submit" class="action-c-btn "-->
                            <!--                                            ><img-->
                            <!--                                                    src="@imgPath/img/svg/icons/next.svg"-->
                            <!--                                                    class="h-28px"-->
                            <!--                                            />Next-->
                            <!--                                            </CButton-->
                            <!--                                            >-->
                            <!--                                        </CCol>-->
                            <!--                                    </CRow>-->
                            <!--<CCol
                                    class="d-flex justify-content-end  curvedBorder "
                                    v-if="
            aprvAgtObj.navBarItems[2].details ||
              aprvAgtObj.navBarItems[1].details
          "
                            >
                                <CButton color="success" type="submit" class="action-c-btn "
                                ><img
                                        src="@imgPath/img/svg/icons/next.svg"
                                        class="h-28px"
                                />Next
                                </CButton
                                >
                            </CCol>-->
                        </CCardBody>
                        <div class="d-flex justify-content-end card-footer " v-if="aprvAgtObj.navBarItems[2].details || aprvAgtObj.navBarItems[1].details">
                            <div class="pl-0px col">
                                <button type="button" class="btn action-c-btn btn-danger"  @click="cancelButton()"><img
                                        src="@imgPath/img/svg/icons/back-circle.svg"> {{ $t("approveAgt.back") }}
                                </button>
                            </div>
                            <div class="pr-0px col d-flex justify-content-end">
                                <button  class="btn action-c-btn btn-success" type="submit" ><img
                                        src="@imgPath/img/svg/icons/next.svg">{{ $t("approveAgt.nextBtn") }}
                                </button>
                            </div>
                        </div>
                    </CForm>

                    <!-- </CForm>
                </ValidationObserver> -->
                </ValidationObserver>
            </div>

            <!-- agent type -->

            <div v-if="!isShowAgentTable">
                <ValidationObserver v-slot="{ handleSubmit }">
                    <CForm @submit.prevent="handleSubmit(showAlertModal)"
                           v-if="aprvAgtObj.navBarItems[3].details">
                        <CCardBody

                                class=" curvedBorder m-auto "
                        >


                            <label>
                                <strong>
                                    {{ $t("approveAgt.payName") }}
                                </strong>
                            </label>
                            <div class="row">

                                <div class="cus-checkbox">
                                    <div class="wrapper">

                                        <div class="card-wrap">
                                            <div class="wrap"
                                                 v-for="(payList, index) in paymentListGroup"
                                                 :key="'p'+index">
                                                <!-- <div class="title"><strong>System Payment</strong></div> -->

                                                <!-- <CRow>
                                                    <CCol> -->
                                                <div>
                                                    <CRow>
                                                        <div class="title">
                                                            <strong>{{payList.groupName}}</strong></div>
                                                    </CRow>
                                                    <CRow>

                                                        <label
                                                                class="card-c "
                                                                :for="payList.groupName+index"
                                                                v-for="(payment, index) in payList.payment"
                                                                :key="payList.groupName+index"
                                                                v-bind:class="{active: aprvAgtObj.paymentSettingId.includes(payment.paymentSettingsId)}">
                                                            <!-- <div v-if="payment.groupName=='eWallet'"> -->
                                                            <input
                                                                    class="d-none"
                                                                    type="checkbox"
                                                                    :checked='aprvAgtObj.paymentSettingId.includes(payment.paymentSettingsId)'
                                                                    @input="onPaymentTypeChange(payment.paymentSettingsId)"
                                                                    :id="payList.groupName+index"
                                                            />
                                                            <div> {{ payment.providerName }}</div>
                                                            <!-- {{payment.paymentSettingsId}}
                                                            {{aprvAgtObj.paymentSettingId}} -->
                                                            <!-- </div> -->
                                                        </label>
                                                    </CRow>
                                                </div>
                                                <!-- </CCol>
                                              </CRow> -->

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div>


                                    </div>
                                </div>
                            </div>
                            <!--                    <div v-for="(payment, index) in paymentList" :key="index">-->
                            <!--                      <input-->
                            <!--                        type="checkbox" :checked='aprvAgtObj.paymentSettingId.includes(payment.paymentSettingsId)' -->
                            <!--                        @input="onPaymentTypeChange(payment.paymentSettingsId)"-->
                            <!--                      />-->
                            <!--                      {{ payment.providerName }}-->
                            <!--                    </div>-->


                            <div v-if="(invalidText)">
                                <label class='invalid-feedback icon'>
                                    {{$t('approveAgt.invalidPaymentType')}}
                                </label>

                            </div>
                            <!--                                        <div class="verticalspace"/>-->





                        </CCardBody>
                        <div class="card-footer">
                            <CRow class="d-flex justify-content-end ">
                                <CCol>
                                    <CButton
                                            color="danger"
                                            @click="cancelButton()"
                                            class="action-c-btn "
                                    ><img
                                            src="@imgPath/img/svg/icons/close.svg"
                                    />{{$t('approveAgt.cancel')}}
                                    </CButton
                                    >
                                </CCol>
                                <CCol class="d-flex justify-content-end">
                                    <CButton color="success" type="submit" class="action-c-btn "
                                    ><img src="@imgPath/img/svg/icons/correct.svg"/>
                                        {{$t('approveAgt.approve')}}
                                    </CButton
                                    >
                                </CCol>
                            </CRow>
                        </div>
                    </CForm>
                </ValidationObserver>
            </div>

            <!-- <cAlertModal
              :buttonList="[
                {
                  name: $t('approveAgt.setUpComm'),
                  func: navToDashboard,
                  color: 'danger'
                }
              ]"
              :status="1"
              :show="aprvAgtObj.agtType.cancelModal"
              :desc="$t('approveAgt.approvMsg')"
            ></cAlertModal> -->
            <cAlertModal v-if="aprvAgtObj.agtType.cancelModal"
                         :buttonList="buttonList"
                         :status="modalStatus"
                         :show="aprvAgtObj.agtType.cancelModal"
                         :desc="confirmText"
            ></cAlertModal>
        </CCard>
    
    
       </div>
 </component>
  <!-- </ion-content>  -->

    

</template>

<script>
import { cloneDeep, onOpenLink } from "../../util/util.js";

    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import {
        COMPONENT_NAME,
        PATHNAME,
        BREADCRUMB_STATUS,
        APPROVEAGENT,
        AGENT_REGISTRATION_STATUS,
        ALERT_MODAL_STATUS,ORDER,ALL_CLIENT_CODE
    } from "../../util/constants.js";
    import {mapGetters} from "vuex";
    import {mapActions} from "vuex";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import cCurrencyBoxes from "../../components/currency/cCurrencyBoxes";
    import cAlertModal from "../../components/form/cAlertModal";
    import SERVICE_URL from "../../config/API_DATA";
    import cDropDown from "../../components/form/cDropDown";
    import {
        cloneData,
        handleJWT,
        getErrorAlertValue,
        addClassToBody,
        removeClassBody,
        GroupByList,OrderByList
    } from "../../util/util";

    import cBreadCrumb from "../../components/breadcrumb/cBreadCrumb";
    import {ValidationObserver, localize} from "vee-validate";
    import apiGetPaymentListAgtApproval from "../../services/apiGetPaymentListAgtApproval";
    import {ValidationProvider} from "vee-validate";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    import cOrgCurrencyDp from "../../components/currency/cOrgCurrencyDp";
    import cCurrencyDropDown from "../../components/currency/cCurrencyDropDown";
    import cRadioButton from "../../components/form/cRadioButton";
    import apiGetAgentDetails from "../../services/apiGetAgentDetails.js";
    import cAgent from "../../components/form/cAgent";
    import router, {navigate, goBack, updateDataEdited} from "../../router/index";
    import apiRejectAgent from "../../services/apiRejectAgent.js";
    import apiApproveAgent from "../../services/apiApproveAgent.js";
    import apiGetMenuCount from "../../services/apiGetMenuCount.js";
    import Logger from "../../services/logger";
    import BaseConfiguration from "../../config/base";
    import apiPendingAgtApproval from "../../services/apiPendingAgtApproval";
    // import nb from "../../translations/validation/nb.json";
    // import en from "../../translations/validation/en.json";
// import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
// import cFullScreen from "../../components/cFullScreen";
import cHelpTip from "../../components/cHelpTip";
// import cManageColumns from "../../components/dataTable/cManageColumns";
import cTable from "../../components/dataTable/cTable";

    // localize({
    //     en: {
    //         messages: en.messages
    //     },
    //     nb: {
    //         messages: nb.messages
    //     }
    // });
    export default {
        name: COMPONENT_NAME.APPROVE_AGENT,
        components: {
            ValidationObserver,
            cDropDown,
            cCurrencyDropDown,
            cBreadCrumb,
            cTextInputComponent,
            cRadioButton,
            cAlertModal,
            ValidationProvider,
            cAgent,
            cOrgCurrencyDp,
            cCurrencyBoxes,
        
          
            cHelpTip,
          
            cTable
        },
        data: () => ({
            isMobile: BaseConfiguration.isMobile,
            clientCode:BaseConfiguration.clientCode,
            allClientCode:ALL_CLIENT_CODE,
              approveAgtTableWatchList:{
            filteredlistCount:null,
            itemsPerPage:25,
            currentPageNum:1
            },
            invalidText: null,
            currency: null,
            paymentList: [],
            paymentListGroup: null,
            pendingAgentList: [],
            isShowAgentTable: true,
            buttonList: [],
            modalStatus: ALERT_MODAL_STATUS.INFO,
            confirmText: null,
            // isShowAgentDetail : false,
            aprvAgtObj: {
                navBarItems: null,
                paymentSettingId: [],
                agencyInfo: {
                    agencyDet: null,
                    approved: false
                },
                selCity: {
                    showState: false,
                    country: null,
                    state: null
                },
                payMethod: {
                    currency: null,
                    paymentType: null
                },
                agtType: {
                    cancelModal: false,
                    agentType: {
                        value: APPROVEAGENT.POSTPAID
                    },
                    postPaidType: {
                        selTypeVal: null,
                        showSch: true,
                        currencyObj: null,
                        payTypeList: null,
                        paymentMethod: [],
                        creditLimitLs: null,
                        selCreditLimit: null,
                        extensionTime:null,
                        isBlockStatement: false,
                    }
                },
                isAdvanceSettings: false
            },

            regStatus: {
                pending: AGENT_REGISTRATION_STATUS.PENDING,
                approved: AGENT_REGISTRATION_STATUS.APPROVED,
                rejected: AGENT_REGISTRATION_STATUS.REJECTED
            },
            isLoading:true,
            pendingAgentListFields:null
       //fullscreen: false

        }),

         created() {
             this.pendingAgentListFields=this.getPendingAgentField();
          this.reCreate();
        },
        // watch: {
        //         "aprvAgtObj.payMethod.currency" : function(val) {

        //             try {
        //               alert(val);
        //                 // if (BaseConfiguration.isDebug) console.log(" topUpAmt");
        //                 this.aprvAgtObj.payMethod.currency.amount = this.$options.filters.formatNumber(val);
        //             } catch (err) {
        //                 let body = Logger.buildRequest(PATHNAME.APPROVE_AGENT, "", err.toString(), "currency", LOG_TYPE.ERROR);
        //                 Logger.getResponse(body);
        //             }
        //         },
        //     },
        methods: {
            ...mapActions("sApproveAgt", ["SET_AGENT_DETAIL_REQ"]),
            ...mapActions("sApproveAgt", ["SET_AGENT_DETAIL_RES"]),
            ...mapActions("sApproveAgt", ["SET_ALL_AGENT_RES"]),
            ...mapActions("sApproveAgt", ["SET_APPROVE_AGENT_REQ"]),
            ...mapActions("sApproveAgt", ["SET_APPROVE_AGENT_RES"]),
            ...mapActions("sApproveAgt", ["SET_REJECT_AGENT_REQ"]),
            ...mapActions("sApproveAgt", ["SET_REJECT_AGENT_RES"]),
            ...mapActions("sApproveAgt", ["CLEAR_APPROVE_AGT_STORE"]),
            ...mapActions("sCountryList", ["SET_COUNTRY_CODE"]),
            ...mapActions("sApproveAgt", ["SET_PAY_TYPE_DATA"]),
            ...mapActions("sApproveAgt", ["SET_POSTPAID_SCH_RES"]),
            ...mapActions("sMenus", ["SET_MENU_COUNT_RES"]),
            ...mapActions("sGuide", ["SET_NAV_FROM_VALUE"]),
//        toggle () {
//         this.$refs['fullscreen'].toggle() 
//         // recommended
//         // this.fullscreen = !this.fullscreen // deprecated
//       },
// fullscreenChange (fullscreen) {
//         this.fullscreen = fullscreen
//       },

 onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.pendingAgentListFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
            FILE_NAME.APPROVE_AGENT,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
  doRefresh(event) {
      this.reCreate();

            if(this.paymentList && this.pendingAgentList) {
                event.target.complete();
            }

      
    },
    async reCreate() {
        try {
          if(BaseConfiguration.isDebug) console.log("reCreate");
           this.getNavBarItems();
            this.getpayTypeList();
            this.getCreditLimitVal();
            
            this.paymentList = await this.getPaymentList();
            this.pendingAgentList = await this.getPendingAgentList();
             
          this.pendingAgentList =OrderByList(this.pendingAgentList,this.getPropToSortAgents,ORDER.DESC);

            if (this.paymentList.length > 0) {
                this.paymentListGroup = GroupByList(this.paymentList, "groupName", "payment"); ///list of routes grouped by depcode
            }
            // if(this.paymentListGroup){
            // if(this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.POSTPAID) { 
            //     this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,false);
            // }else{
            //     this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,true);          
            // }
            //  }
             this.isLoading=false;
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.APPROVE_AGENT,
                  "error in reCreate",
                  err.toString(),
                  "reCreate",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
   }, 
navToGuide() {
    try {
      if(BaseConfiguration.isDebug) console.log("navToGuide");
      this.SET_NAV_FROM_VALUE(COMPONENT_NAME.APPROVE_AGENT)
    onOpenLink(window.location.origin+'/#'+PATHNAME.GUIDE)
    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.APPROVE_AGENT,
              "error in navToGuide",
              err.toString(),
              "navToGuide",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
      
    }, 
            navigateToState() {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToState");
                  navigate(PATHNAME.STATE_PROVINCE)
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.APPROVE_AGENT,
                          "error in navigateToState",
                          err.toString(),
                          "navigateToState",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            }, 

    onPaginationChange(pItemsPerPage) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPaginationChange");
           this.approveAgtTableWatchList.itemsPerPage=pItemsPerPage;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.APPROVE_AGENT,
                  "error in onPaginationChange",
                  err.toString(),
                  "onPaginationChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onPageChange(pPageNum) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPageChange");
    this.approveAgtTableWatchList.currentPageNum=pPageNum;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.APPROVE_AGENT,
                  "error in onPageChange",
                  err.toString(),
                  "onPageChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

    getFilteredAgentCount(pFilteredItems) {
        try {
          if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
         this.approveAgtTableWatchList.filteredlistCount=pFilteredItems.length;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.APPROVE_AGENT,
                  "error in getFilteredAgentCount",
                  err.toString(),
                  "getFilteredAgentCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
 async getMenuCount() {
      let returnValue;
      try {
        let menuCountReq = apiGetMenuCount.buildRequest();

        if (menuCountReq != null) {
          

          let menuCountRes = await apiGetMenuCount.getResponse(menuCountReq);
          if (VALIDATE_SUCCESS_RES(menuCountRes)) {
            returnValue = menuCountRes.data.data;
           
            
          } else {
            let error = getErrorMessage(menuCountRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            } else {
              returnValue = [];
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.APPROVE_AGENT,
          "error in getting getMenuCount",
          err.toString(),
          "getMenuCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
},

            getPropToSortAgents(pAgent) {
                try {
                  if(BaseConfiguration.isDebug) console.log("getPropToSortAgents");
                if(pAgent.created_at){
                    
                    return pAgent.created_at;
                }
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.APPROVE_AGENT,
                          "error in getPropToSortAgents",
                          err.toString(),
                          "getPropToSortAgents",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                }, 

            showAlertModal(status) {
                try {
                    if (BaseConfiguration.isDebug) console.log("showAlertModal");
                    //let retValue;
                    this.aprvAgtObj.agtType.cancelModal = true;
                    if (status) {
                        this.modalStatus = status;
                    }
                    let desc = null;
                    if (this.modalStatus == ALERT_MODAL_STATUS.INFO) {
                        this.buttonList = [
                            {
                                name: this.$t('approveAgt.noBtn'),
                                func: this.cancelModal,
                                color: 'danger'
                            },
                            {
                                name: this.$t('approveAgt.yesBtn'),
                                func: this.approveAgent,
                                color: 'success'
                            }
                        ]
                        desc = this.$t('approveAgt.confirmApprove', {agent: this.aprvAgtObj.agencyInfo.agencyDet.agencyname})
                    } else if (this.modalStatus == ALERT_MODAL_STATUS.SUCCESS) {
                        this.buttonList = [
                            {
                                name: this.$t('approveAgt.setUpComm'),
                                func: this.navToAssignPricing,
                                color: 'danger'
                            }
                        ]
                        desc = this.$t('approveAgt.approvMsg') + '\n' + this.$t('approveAgt.agentCode', {code: this.agentCode.id})
                    }
                    this.confirmText = desc;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in showAlertModal",
                        err.toString(),
                        "showAlertModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            onPaymentTypeChange(pPaymentId) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPaymentTypeChange");
                    this.invalidText = false;
                    if (
                        pPaymentId != null &&
                        this.aprvAgtObj.paymentSettingId &&
                        this.aprvAgtObj.paymentSettingId.includes(pPaymentId) == false
                    ) {
                        this.aprvAgtObj.paymentSettingId.push(pPaymentId);
                    } else if (
                        pPaymentId &&
                        this.aprvAgtObj.paymentSettingId &&
                        this.aprvAgtObj.paymentSettingId.length
                    ) {
                        this.aprvAgtObj.paymentSettingId = this.aprvAgtObj.paymentSettingId.filter(
                            id => {
                                return id != pPaymentId;
                            }
                        );
                    }


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onPaymentTypeChange",
                        err.toString(),
                        "onPaymentTypeChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            async getPaymentList() {
                let returnValue;
                try {
                    let paymentListReq = apiGetPaymentListAgtApproval.buildRequest();
                    if (paymentListReq) {
                        let paymentListRes = await apiGetPaymentListAgtApproval.getResponse(
                            paymentListReq
                        );
                        if (
                            VALIDATE_SUCCESS_RES(paymentListRes) &&
                            paymentListRes.data.data.length > 0
                        ) {
                            //save res in store
                            returnValue = paymentListRes.data.data;
                        } else {
                            let error = getErrorMessage(paymentListRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                            returnValue = [];
                        }
                    } else {
                        throw "invalid request"; //
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in  getPaymentList  ",
                        err.toString(),
                        "getPaymentList",
                        LOG_TYPE.ERROR
                    );
                }

                return returnValue;
            },

            getDefaultdata() {
                try {
                    this.aprvAgtObj.agencyInfo.agencyDet = null;
                    this.aprvAgtObj.selCity.country = null;
                    this.aprvAgtObj.selCity.state = null;
                    this.aprvAgtObj.payMethod.currency = null;
                    this.aprvAgtObj.payMethod.paymentType = null;
                    this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.POSTPAID
                   this.aprvAgtObj.agtType.postPaidType.selTypeVal = {
                        name: this.$t("approveAgt.weekly"),
                        code: "W",
                        value: "1"
                    };
            //         if(this.paymentListGroup){
            // if(this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.POSTPAID) { 
            //     this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,false);
            // }else{
            //     this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,true);          
            // }
            //  }
                    this.aprvAgtObj.paymentSettingId = [];
                    this.isShowAgentTable = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getDefaultdata",
                        err.toString(),
                        "getDefaultdata",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            navToAssignPricing() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToAssignPricing");
                    this.aprvAgtObj.agtType.cancelModal = false;
                    this.getDefaultdata();
                    navigate(PATHNAME.ASSIGN_PRICING);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in navToAssignPricing",
                        err.toString(),
                        "navToAssignPricing",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            toDisableAgentDP() {
                let retValue;
                try {
                    if (
                        this.aprvAgtObj.agencyInfo &&
                        this.aprvAgtObj.agencyInfo.agencyDet &&
                        this.aprvAgtObj.agencyInfo.agencyDet.registrationid &&
                        !this.aprvAgtObj.navBarItems[0].details &&
                        this.aprvAgtObj.agencyInfo.agencyDet.agencyname != null
                    ) {
                        retValue = true;
                    } else {
                        retValue = false;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in toDisableAgentDP",
                        err.toString(),
                        "toDisableAgentDP",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

                return retValue;
            },

            getNavBarItems() {
                try {
                    this.aprvAgtObj.navBarItems = [
                        {
                            id: 0,
                            name: this.$t("approveAgt.bcItem.agncyInfo"),
                            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
                            details: false
                        },
                        {
                            id: 1,
                            name: this.$t("approveAgt.bcItem.selCity"),
                            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
                            details: false
                        },
                        
                        {
                            id: 2,
                            name: this.$t("approveAgt.bcItem.agtType"),
                            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
                            details: false
                        },
                        {
                            id: 3,
                            name: this.$t("approveAgt.bcItem.paymethod"),
                            status: BREADCRUMB_STATUS.BREADCRUMB_ITEM,
                            details: false
                        },
                    ];
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getNavBarItems",
                        err.toString(),
                        "getNavBarItems",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getpayTypeList() {
                try {
                    this.aprvAgtObj.agtType.postPaidType.payTypeList = [
                        {
                            name: this.$t("approveAgt.weekly"),
                            code: "W",
                            value: "1"
                        },
                        {
                            name: this.$t("approveAgt.twice"),
                            code: "TW",
                            value: "2"
                        },
                        {
                            name: this.$t("approveAgt.monthly"),
                            code: "M",
                            value: "3"
                        }
                    ];
                    this.aprvAgtObj.agtType.postPaidType.selTypeVal = {
                        name: this.$t("approveAgt.weekly"),
                        code: "W",
                        value: "1"
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getpayTypeList",
                        err.toString(),
                        "getpayTypeList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getCreditLimitVal() {
                try {
                    if(this.clientCode==this.allClientCode.MF){
                        this.aprvAgtObj.agtType.postPaidType.creditLimitLs = [
                        {
                            name: this.$t("approveAgt.fixed"),
                            code: "F",
                            value: "1"
                        },
                        
                        
                    ];

                    }else{
                        this.aprvAgtObj.agtType.postPaidType.creditLimitLs = [
                        {
                            name: this.$t("approveAgt.fixed"),
                            code: "F",
                            value: "1"
                        },
                        {
                            name: this.aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'W' ?
                                    this.$t("approveAgt.repWeekly") : this.aprvAgtObj.agtType.postPaidType.selTypeVal.code == 'TW' ?
                                    this.$t("approveAgt.repTwice") : this.$t("approveAgt.repMonthly") ,
                            code: "MTW",
                            value: "2"
                        },
                        
                    ];
                    }
                    
                    this.aprvAgtObj.agtType.postPaidType.selCreditLimit = {
                        name: this.$t("approveAgt.fixed"),
                        code: "F",
                        value: "1"
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getCreditLimitVal",
                        err.toString(),
                        "getCreditLimitVal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            rejModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("rejModal");
                    if (this.aprvAgtObj && this.aprvAgtObj.agencyInfo) {
                        this.aprvAgtObj.agencyInfo.approved = true;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in rejModal",
                        err.toString(),
                        "rejModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getAllPendingAgentServiceURL() {
                if (BaseConfiguration.isDebug)
                    console.log("getAllPendingAgentServiceURL");
                // alert(SERVICE_URL.PENDING_AGENT);
                return SERVICE_URL.PENDING_AGENT;
            },

            getCountryServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
                return SERVICE_URL.GET_COUNTRY_LIST;
            },

            getStateServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getStateServiceURL");

                return SERVICE_URL.GET_STATE_LIST;
            },

            getCurrencyServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
                return SERVICE_URL.GET_CURRENCY_LIST;
            },

            getOrgCurrencyServiceURL() {
                if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
                return SERVICE_URL.GET_ORG_CURRENCY;
            },

            getPaymentMethodURL() {
                if (BaseConfiguration.isDebug) console.log("getPaymentMethodURL");
                return SERVICE_URL.GET_PAYMENT_LIST_AGT_APPROVAL;
            },

            getPaymentScheduleURL() {
                if (BaseConfiguration.isDebug) console.log("getPaymentScheduleURL");
                return SERVICE_URL.PAYMENT_SCHEDULE;
            },

            toChangePayListType(payListGrp,pIsPrepaid) {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toChangePayListType");
                 let typeGrp;
                     for (let i = 0; i < payListGrp.length; i++) {
                         if(payListGrp[i].groupName == "Prepaid Balance / Postpaid Credit"){
                             for(let j=0; j <payListGrp[i].payment.length; j++){
                             if((payListGrp[i].payment[j].providerName == "Hold (Prepaid)" || payListGrp[i].payment[j].providerName == "Hold (Postpaid)") 
                                    && payListGrp[i].payment[j].providerType == "A24.PREPAID.HOLD"){
                                 if(pIsPrepaid){
                                     payListGrp[i].payment[j].providerName = "Hold (Prepaid)";
                                 }else if(!pIsPrepaid) {
                                     payListGrp[i].payment[j].providerName = "Hold (Postpaid)"
                                 }
                             }
                              if((payListGrp[i].payment[j].providerName == "Ticket Now (Prepaid)" || payListGrp[i].payment[j].providerName == "Ticket Now (Postpaid)") 
                                            && payListGrp[i].payment[j].providerType == "A24.PREPAID"){
                                 if(pIsPrepaid){
                                     payListGrp[i].payment[j].providerName = "Ticket Now (Prepaid)";
                                 }else if(!pIsPrepaid) {
                                     payListGrp[i].payment[j].providerName = "Ticket Now (Postpaid)"
                                 }
                             }
                         }
                         }  
                     }
                 retValue = payListGrp;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.APPROVE_AGENT,
                          "error in toChangePayListType",
                          err.toString(),
                          "toChangePayListType",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            }, 

            onAgentTypeChange() {
                try {
                    if(this.clientCode!=this.allClientCode.AZ) {
                    if (this.aprvAgtObj.agtType.agentType.value == APPROVEAGENT.PREPAID) {
                        this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.POSTPAID;
                        // if(this.paymentListGroup){
                        //    this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,false); 
                        // }
                    } else {
                        this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.PREPAID;
                        // if(this.paymentListGroup){
                        //     this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,true);
                        // }
                    }
                    } else{
                       this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.POSTPAID; 
                    //    if(this.paymentListGroup){
                    //        this.paymentListGroup = this.toChangePayListType(this.paymentListGroup,false); 
                    //     }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onAgentTypeChange",
                        err.toString(),
                        "onAgentTypeChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onScheduleChange(selScheduleObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onScheduleChange");

                    this.aprvAgtObj.agtType.postPaidType.paymentMethod = selScheduleObj;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onScheduleChange",
                        err.toString(),
                        "onScheduleChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            // onOrgCurrencyChange(selCurrencyObj) {
            // try {
            // if(BaseConfiguration.isDebug) console.log("onOrgCurrencyChange");

            // this.currency = selCurrencyObj;
            // } catch (err) {
            //         let body = Logger.buildRequest(
            //           FILE_NAME.APPROVE_AGENT,
            //           "error in onOrgCurrencyChange",
            //           err.toString(),
            //           "onOrgCurrencyChange",
            //           LOG_TYPE.ERROR
            //         );
            //         Logger.getResponse(body);
            //       }
            // },

            onCurrencyChange(selCurrencyObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCurrencyChange");
                    let currList = []
                    if(this.aprvAgtObj.payMethod.currency && this.aprvAgtObj.payMethod.currency.length>selCurrencyObj.length){
                           let deselectedObj =  this.aprvAgtObj.payMethod.currency.filter(o1 => !selCurrencyObj.some(o2 => o1.id === o2.id));
                           loop1:for (let i = 0; i < this.aprvAgtObj.payMethod.currency.length; i++) {
                               loop2:for (let j = 0; j < deselectedObj.length; j++) {
                                   if(this.aprvAgtObj.payMethod.currency[i].id == deselectedObj[j].id){
                                       this.$delete(this.aprvAgtObj.payMethod.currency,i);
                                       i--;
                                       break loop2;
                                   }   
                               }   
                           }
                        }

                    for (let i = 0; i < selCurrencyObj.length; i++) {
                        if((!this.aprvAgtObj.payMethod.currency || !this.aprvAgtObj.payMethod.currency[i] ||
                        !this.aprvAgtObj.payMethod.currency[i].hasOwnProperty('amount'))){
                            let currObj = selCurrencyObj[i];
                            currObj['amount'] = ""
                        selCurrencyObj[i]["amount"] = "";
                        currList.push(currObj) ;
                        }
                       else{
                           currList.push( this.aprvAgtObj.payMethod.currency[i]) ;
                       }
                    }
                        this.aprvAgtObj.payMethod.currency = currList
                   
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onCurrencyChange",
                        err.toString(),
                        "onCurrencyChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onAgentChange(pSelAgtObj) {
                // alert(JSON.stringify(pSelAgtObj));
                try {

                    this.isShowAgentTable = false;
                    // this.isShowAgentDetail = true;
                    this.aprvAgtObj.agencyInfo.agencyDet = pSelAgtObj;
                    this.aprvAgtObj.navBarItems[0].details = true; // visibility of agent info

                    this.aprvAgtObj.navBarItems[0].status =
                        BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                        " " +
                        BREADCRUMB_STATUS.PRESENT_ITEM;

                        updateDataEdited(true);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onAgentChange",
                        err.toString(),
                        "onAgentChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onPaymentMethodChange(pSelPayTypeObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onPaymentMethodChange");
                    this.aprvAgtObj.payMethod.paymentType = pSelPayTypeObj;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onPaymentMethodChange",
                        err.toString(),
                        "onPaymentMethodChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onStateChange(selStateObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onStateChange");
                    if (this.aprvAgtObj && this.aprvAgtObj.selCity) {
                        this.aprvAgtObj.selCity.state = selStateObj;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onStateChange",
                        err.toString(),
                        "onStateChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onPayTypeChange(newValue) {
                try {
                    if (this.aprvAgtObj.agtType.postPaidType.selTypeVal != newValue) {
                        this.aprvAgtObj.agtType.postPaidType.paymentMethod=[];
                        //this.aprvAgtObj.agtType.postPaidType.showSch = false;
                        if (
                            this.aprvAgtObj &&
                            this.aprvAgtObj.agtType &&
                            this.aprvAgtObj.agtType.postPaidType
                        ) {
                            this.aprvAgtObj.agtType.postPaidType.selTypeVal = newValue;

                            this.SET_PAY_TYPE_DATA(
                                this.aprvAgtObj.agtType.postPaidType.selTypeVal
                            );
                        }
                        this.getCreditLimitVal();
                        // if (this.payTypeData.name == "Monthly") {
                        //     this.SET_POSTPAID_SCH_RES([this.postSchRes[0]]);
                        // } else {
                        //     this.SET_POSTPAID_SCH_RES(this.actualPostSchRes);
                        // }
                        if(this.aprvAgtObj.agtType.postPaidType.selTypeVal.code=='W'){
                        this.SET_POSTPAID_SCH_RES(this.actualPostSchRes);
                        }else{
                            // this.aprvAgtObj.agtType.postPaidType.paymentMethod=this.postSchRes[0];
                             this.SET_POSTPAID_SCH_RES([this.postSchRes[0]]);
                        }
                       
                        let that = this;
                        this.aprvAgtObj.agtType.postPaidType.showSch = false;
                        setTimeout(function () {
                            that.aprvAgtObj.agtType.postPaidType.showSch = true;
                        });
                    }else{
                        if(this.aprvAgtObj.agtType.postPaidType.selTypeVal&&this.aprvAgtObj.agtType.postPaidType.selTypeVal.code=='W'){
                        this.SET_POSTPAID_SCH_RES(this.actualPostSchRes);
                        }else{
                            // this.aprvAgtObj.agtType.postPaidType.paymentMethod=this.postSchRes[0];
                             this.SET_POSTPAID_SCH_RES([this.postSchRes[0]]);
                        }
                    }
                    
                   
                    if (BaseConfiguration.isDebug) console.log("onPayTypeChange");
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onPayTypeChange",
                        err.toString(),
                        "onPayTypeChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onToggleBlockTicket() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onToggleBlockTicket");
                  this.aprvAgtObj.agtType.postPaidType.isBlockStatement = !this.aprvAgtObj.agtType.postPaidType.isBlockStatement;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.APPROVE_AGENT,
                          "error in onToggleBlockTicket",
                          err.toString(),
                          "onToggleBlockTicket",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
            }, 

            onCreditLimitChange(newValue) {
                try {
                    if (this.aprvAgtObj.agtType.postPaidType.selCreditLimit != newValue) {
                       
                        //this.aprvAgtObj.agtType.postPaidType.showSch = false;
                        if (
                            this.aprvAgtObj &&
                            this.aprvAgtObj.agtType &&
                            this.aprvAgtObj.agtType.postPaidType
                        ) {
                            this.aprvAgtObj.agtType.postPaidType.selCreditLimit = newValue;

                        }
                        
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onCreditLimitChange",
                        err.toString(),
                        "onCreditLimitChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            // onCurrencyChange(selCurrencyObj) {
            //     try {
            //         if (BaseConfiguration.isDebug) console.log("onCurrencyChange");
            //         for (let i = 0; i < selCurrencyObj.length; i++) {
            //             if(!selCurrencyObj[i].hasOwnProperty('amount')){
            //             selCurrencyObj[i]["amount"] = "";
            //             }
            //         }
            //         this.aprvAgtObj.payMethod.currency = selCurrencyObj;
            //     } catch (err) {
            //         let body = Logger.buildRequest(
            //             FILE_NAME.APPROVE_AGENT,
            //             "error in onCurrencyChange",
            //             err.toString(),
            //             "onCurrencyChange",
            //             LOG_TYPE.ERROR
            //         );
            //         Logger.getResponse(body);
            //     }
            // },
            async approveAgent() {
                let retValue;
                try {
                    this.aprvAgtObj.agtType.cancelModal = false;
                    let apprvAgtReq = apiApproveAgent.buildRequest(this.aprvAgtObj);

                    if (apprvAgtReq) {
                        this.SET_APPROVE_AGENT_REQ(apprvAgtReq); //save req in store
                        let apprvAgtRes = await apiApproveAgent.getResponse(apprvAgtReq);

                        if (VALIDATE_SUCCESS_RES(apprvAgtRes)) {
                            let menuCount = await this.getMenuCount();
                            this.SET_MENU_COUNT_RES(menuCount);
                            this.SET_APPROVE_AGENT_RES(apprvAgtRes.data.data); //save res in store
                            retValue = apprvAgtRes.data.data;
                            // this.$router.go();
                            this.showAlertModal(ALERT_MODAL_STATUS.SUCCESS);
                        } else {
                            this.showAlert = true;
                            let error = getErrorMessage(apprvAgtRes);
                            // let isJwt = handleJWT(true);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid agent";
                    }
                    updateDataEdited(false);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getting response from approveAgent API",
                        err.toString(),
                        "approveAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            async rejectAgent() {
                let retValue;
                try {
                    let rejAgtReq = apiRejectAgent.buildRequest(
                        this.aprvAgtObj.agencyInfo.agencyDet.registrationid
                    );
                    if (rejAgtReq) {
                        this.SET_REJECT_AGENT_REQ(rejAgtReq); //save req in store
                        let rejAgtRes = await apiRejectAgent.getResponse(rejAgtReq);

                        if (VALIDATE_SUCCESS_RES(rejAgtRes)) {
                            this.SET_APPROVE_AGENT_RES(rejAgtRes); //save res in store
                            retValue = rejAgtRes.data.data;
                            this.pendingAgentList = await this.getPendingAgentList();
                            this.showAgentTable();
                            // alert(rejAgtRes.data.data.status);
                            this.aprvAgtObj.agencyInfo.approved = false;
                            this.aprvAgtObj.navBarItems[0].details = false;
                        } else {
                            this.showAlert = true;
                            let error = getErrorMessage(rejAgtRes);
                            // let isJwt = handleJWT(true);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid agent";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getting response from rejectAgent API",
                        err.toString(),
                        "rejectAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            nextButton() {
                try {


                    for (let i = 0; i < this.aprvAgtObj.navBarItems.length; i++) {
                        if (this.aprvAgtObj.navBarItems[i].details == true) {
                            this.showDetails();
                            break;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in nextButton",
                        err.toString(),
                        "nextButton",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            cancelModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("cancelModal");
                    // this.aprvAgtObj.allAgts.approved=false;
                    this.aprvAgtObj.agencyInfo.approved = false;
                    this.aprvAgtObj.agtType.cancelModal = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in cancelModal",
                        err.toString(),
                        "cancelModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            cancelButton() {
                try {
                    for (let i = 0; i < this.aprvAgtObj.navBarItems.length; i++) {
                        if (this.aprvAgtObj.navBarItems[i].details == true) {
                            if (this.aprvAgtObj.navBarItems[i].id == 0) {
                                this.rejModal();
                            } else if (this.aprvAgtObj.navBarItems[i].id == 1) {
                                this.aprvAgtObj.navBarItems[i].details = false;
                                this.aprvAgtObj.navBarItems[i - 1].details = true;
                                this.aprvAgtObj.navBarItems[i - 1].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM;

                            } else if (this.aprvAgtObj.navBarItems[i].id == 2) {
                                this.aprvAgtObj.navBarItems[i].details = false;
                                this.aprvAgtObj.navBarItems[i - 1].details = true;
                                this.aprvAgtObj.navBarItems[i - 1].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM;

                            } else if (this.aprvAgtObj.navBarItems[i].id == 3) {
                                this.navToSelAgtName();
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in cancelButton",
                        err.toString(),
                        "cancelButton",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            showDetails() {
                try {
                    if (BaseConfiguration.isDebug) console.log("showDetails");
                    for (let i = 0; i <= this.aprvAgtObj.navBarItems.length - 1; i++) {
                        if (this.aprvAgtObj.navBarItems[i].details == true) {
                            this.aprvAgtObj.navBarItems[i + 1].details = true;
                            this.aprvAgtObj.navBarItems[i].details = false;
                            break;
                        }

                        // if (this.aprvAgtObj.navBarItems[i].id == 1) {
                        //     // var currObj = cloneData(this.aprvAgtObj.payMethod.currency);
                        //     // this.aprvAgtObj.agtType.postPaidType.currencyObj=currObj;
                            // this.aprvAgtObj.agtType.agentType.value = APPROVEAGENT.PREPAID;
                        // }
                    }
                    this.nextNav();
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in showDetails",
                        err.toString(),
                        "showDetails",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            //navigate to the select agent page
            navToSelAgtName() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToSelAgtName");
                    for (let i = 0; i < this.aprvAgtObj.navBarItems.length; i++) {
                        if (this.aprvAgtObj.navBarItems[i].details == true) {
                            this.aprvAgtObj.navBarItems[i].details = false;
                            this.aprvAgtObj.navBarItems[i].status =
                                BREADCRUMB_STATUS.BREADCRUMB_ITEM;
                        } else {
                            this.aprvAgtObj.navBarItems[i].status =
                                BREADCRUMB_STATUS.BREADCRUMB_ITEM;
                        }
                    }

                    this.aprvAgtObj.agencyInfo.approved = false;

                    this.getNavBarStatus(this.aprvAgtObj.navBarItems);
                    this.getDefaultdata();
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in navToSelAgtName",
                        err.toString(),
                        "navToSelAgtName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            goBackNav() {
                this.getNavBarStatus(this.aprvAgtObj.navBarItems, false);
            },

            nextNav() {
                this.getNavBarStatus(this.aprvAgtObj.navBarItems, true);
            },

            getNavBarStatus(pvalue, isNxt) {
                // alert(JSON.stringify(pvalue));
                try {
                    if (BaseConfiguration.isDebug)
                        console.log("getNavBarStatus" + JSON.stringify(pvalue));

                    for (let i = 0; i < this.aprvAgtObj.navBarItems.length; i++) {
                        if (isNxt) {
                            if (this.aprvAgtObj.navBarItems[i].details == false) {
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PAST_ITEM;
                            } else {
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                break;
                            }
                        } else if (
                            isNxt == false &&
                            this.aprvAgtObj.navBarItems[i].details == true
                        ) {
                            this.aprvAgtObj.navBarItems[i].status =
                                BREADCRUMB_STATUS.BREADCRUMB_ITEM;
                            this.aprvAgtObj.navBarItems[i].details = false;

                            this.aprvAgtObj.navBarItems[i - 1].details = true;
                        }
                        if (isNxt == undefined) {
                            if (i == pvalue.id) {
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PRESENT_ITEM;
                                this.aprvAgtObj.navBarItems[i].details = true;
                            } else if (i < pvalue.id) {
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM +
                                    " " +
                                    BREADCRUMB_STATUS.PAST_ITEM;
                                this.aprvAgtObj.navBarItems[i].details = false;
                            } else {
                                this.aprvAgtObj.navBarItems[i].status =
                                    BREADCRUMB_STATUS.BREADCRUMB_ITEM;
                                this.aprvAgtObj.navBarItems[i].details = false;
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getNavBarStatus",
                        err.toString(),
                        "getNavBarStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            onCountryChange(pSelCountry) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onCountryChange");
                    if (this.aprvAgtObj.selCity.country != pSelCountry) {
                        this.aprvAgtObj.selCity.showState = false;
                        this.aprvAgtObj.selCity.country = pSelCountry;
                        this.aprvAgtObj.selCity.state = null;
                        let that = this;
                        setTimeout(function () {
                            that.aprvAgtObj.selCity.showState = true;
                        });
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in onCountryChange",
                        err.toString(),
                        "onCountryChange",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            showAgentTable() {
                this.isShowAgentTable = true;
                // this.isShowAgentDetail = false;
                this.navToSelAgtName();
            },

            getPendingAgentField() {
                return [
                    {
                        key: "agencyname",
                        label: this.$t("approveAgt.agencyName"),
                        isLocked: true
                    },
                    {
                        key: "contact_name",
                        label: this.$t("approveAgt.agentName"),
                        isLocked: true
                    },
                    
                    {
                        key: "emailid",
                        label: this.$t("approveAgt.mailId"),
                        isLocked: false
                    },
                    {
                        key: "mobile_number",
                        label: this.$t("approveAgt.agtNo"),
                        isLocked: false
                    },
                    {
                        key: "contact_country_name",
                        label: this.$t("approveAgt.agtCountry"),
                        isLocked: false
                    },
                    {
                        key: "contact_state_name",
                        label: this.$t("approveAgt.agtState"),
                        isLocked: false
                    },
                    {
                        key: "created_at",
                        label: this.$t("approveAgt.regDate"),
                        isLocked: false
                    },


                    {
                        key: "status",
                        label: this.$t("approveAgt.status"),
                        sorter: false,
                        isLocked: false

                    },
                    {
                        key: 'action',
                        label: this.$t("approveAgt.action"),
                        sorter: false,
                        isLocked: true
                    }

                ];
            },

            async getPendingAgentList() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getPendingAgentList");
                    let pendingList = [];
                    let pendingAgentReq = apiPendingAgtApproval.buildRequest();

                    if (pendingAgentReq) {
                        let pendingAgentRes = await apiPendingAgtApproval.getResponse(
                            pendingAgentReq
                        );
                        if (VALIDATE_SUCCESS_RES(pendingAgentRes)) {
                            pendingList = pendingAgentRes.data.data;
                            // this.showAcknowledgeAlert();
                        } else {
                            this.showAlert = true;
                            let error = getErrorMessage(pendingAgentRes);
                            // let isJwt = handleJWT(true);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                    return pendingList;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.APPROVE_AGENT,
                        "error in getPendingAgentList",
                        err.toString(),
                        "getPendingAgentList",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },
        },

        computed: {
            ...mapGetters("sApproveAgt", {
                payTypeData: "GET_PAY_TYPE_DATA",
                postSchRes: "GET_POSTPAID_SCH_RES",
                actualPostSchRes: "GET_ACTUAL_POST_SCH_RES",
                agentCode: "GET_APPROVE_AGENT_RES"
            }),
            ...mapGetters("sCountryList", {
                countryRequest: "GET_COUNTRY_REQ",
                countryResponse: "GET_COUNTRY_RES",
                countryCode: "GET_COUNTRY_CODE"
            }),
          //for filtering created_at
       pendingAgentComputedList () {
             let retValue=[];
             let pedingAgentList=cloneData(this.pendingAgentList)
             pedingAgentList.forEach(item => {
              if (item){    
                item.created_at=this.$options.filters.timeAgoFormat(item.created_at);
                retValue.push(item)
                }
               });
              return retValue;
         },
        },

        beforeCreate() {
            addClassToBody(COMPONENT_NAME.APPROVE_AGENT);
        },

        beforeDestroy() {
            removeClassBody();
        },
    };
</script>
<style scoped>
.guide-content{
    padding-right: 7px;
}
</style>
